import Tipe61 from "./6 (1).webp";
import Tipe62 from "./6 (2).webp";
import Tipe63 from "./6 (3).webp";
import Tipe64 from "./6cl.webp";

const tipe6images = [Tipe61, Tipe62, Tipe63, Tipe64];

export default tipe6images;
